import React from "react";

function ErrorPage(){
    return(
        <div>
            404, page not found
        </div>
    )
}
export default ErrorPage;